module.exports = __webpack_public_path__ + "static/img/7.bab4752.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop/product/7.jpg
// module id = wLOV
// module chunks = 1